<template lang="pug">
.c-article-content
  .title.is-2.has-text-primary(v-if="!hideTitle") {{ title }}
  template(v-if="cover")
    div(:class="$style.coverWrapper")
      div(:class="$style.coverPhoto")
        img(:src="$u.get(cover, 'src', '')")
  template(v-if="content")
    div(:class="$style.sub")
      b-icon(
        pack="fas"
        icon="pen")
      div(:class="$style.subtitle")
        span 內容
    .content(v-html="content")
  template(v-if="photos.length > 0")  
    div(:class="$style.sub")
      b-icon(
        pack="far"
        icon="images")
      div(:class="$style.subtitle")
        span 圖片
    gallery(:items="displayPhotos")
    .has-text-centered(v-if="!showAll" :style="{ padding: '2rem' }")
      b-button(type="is-warning" @click="showMore") 顯示更多圖片
  template(v-if="files.length > 0")
    div(:class="$style.sub")
      b-icon(
        pack="far"
        icon="file")
      div(:class="$style.subtitle")
        span 檔案
    b-table(:data="files")
      template(v-slot="{ row }")
        b-table-column(field="title"
          label="名稱") {{ row.title }}
        b-table-column(field="size"
          label="大小") {{ getSize(row.size) }}
        b-table-column(field="download"
          label="下載")
          base-url-provider(:filepath="row.name")
            template(v-slot="{ url }")
              b-button(type="is-warning"
                rounded
                @click="download(url)")
                b-icon(pack="fas"
                  :icon="getIcon(row.ext)")
</template>

<script>
import Gallery from "@/components/Gallery.vue";
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";

export default {
  name: "ArticleContent",
  components: {
    Gallery,
    BaseUrlProvider
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    cover: {
      type: Object,
      default: null
    },
    content: {
      type: String,
      default: ""
    },
    photos: {
      type: Array,
      default: () => []
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      displayPhotos: this.photos.slice(0, 100)
    };
  },
  computed: {
    showAll() {
      return this.displayPhotos.length >= this.photos.length;
    }
  },
  methods: {
    download(url) {
      window.open(url);
    },
    getSize(size) {
      if (size / 1024 / 1024 > 1) {
        return Math.floor(size / 1024 / 1024) + " MB";
      }
      return Math.floor(size / 1024) + " KB";
    },
    getIcon(ext) {
      const map = {
        ".doc": "file-word",
        ".docx": "file-word",
        ".ppt": "file-powerpoint",
        ".pptx": "file-powerpoint",
        ".xls": "file-excel",
        ".xlsx": "file-excel",
        ".pdf": "file-pdf",
        ".jpg": "file-image",
        ".png": "file-image"
      };

      return map[ext] || "file";
    },
    showMore() {
      this.displayPhotos = this.displayPhotos.concat(
        this.photos.slice(
          this.displayPhotos.length,
          this.displayPhotos.length + 100
        )
      );
    }
  }
};
</script>

<style module lang="sass">
.coverWrapper
  width: 100%
  max-width: 600px
  margin: auto
  .coverPhoto
    +ratioImage(3, 2)
    img
      object-fit: contain

.sub
  position: relative
  margin: pxRem(32) 0
  &:after
    +size(pxRem(100), 2px)
    content: ''
    position: absolute
    left: 0
    bottom: pxRem(-8)
    background-color: $warning
  > *
    display: inline-block
  .subtitle
    padding: 0 pxRem(8)
    font-weight: bold
    color: $grey
</style>
